import React from "react";
import { Fragment } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//import GBM from "../static/images/gbm.png";
//import cargill from "../static/images/cargill-logo.png";
import Nestle from "../static/images/Nestle-logo.png";
import Carnic from "../static/images/rsz_1logo-nuevo-carnic.png";
import Bimbo from "../static/images/Logo_Grupo_BIMBO.png";
import cafelasflores from "../static/images/cafe-las-flores-logo.png";
import MiviejoRanchito from "../static/images/Mi-Viejo-Ranchito.jpg";
import PizzaHut from "../static/images/Pizza-Hut-Logo.jpg";
import SuperHerramientas from "../static/images/Super-Herramientas-logo.jpg";
import TGIFridays from "../static/images/TGI-Fridays-Logo.png";
import Oryx from "../static/images/Oryx-Soluciones.jpg";

function SliderAliados() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 5000,
    arrows: false,
  };

  return (
    <Fragment>
      <div id="owl-aliados">
        <Slider {...settings}>
          <div className="item" id="Itemaliados">
            <img src={Nestle} alt=""></img>
          </div>
          <div className="item" id="Itemaliados">
            <img src={Carnic} alt=""></img>
          </div>
          <div className="item" id="Itemaliados">
            <img src={cafelasflores} alt=""></img>
          </div>
          <div className="item" id="Itemaliados">
            <img src={Bimbo} alt=""></img>
          </div>
          <div className="item" id="Itemaliados">
            <img src={MiviejoRanchito} alt=""></img>
          </div>
          <div className="item" id="Itemaliados">
            <img src={PizzaHut} alt=""></img>
          </div>
          <div className="item" id="Itemaliados">
            <img src={SuperHerramientas} alt=""></img>
          </div>
          <div className="item" id="Itemaliados">
            <img src={TGIFridays} alt=""></img>
          </div>
          <div className="item" id="Itemaliados">
            <img src={Oryx} alt=""></img>
          </div>
        </Slider>
      </div>
    </Fragment>
  );
}

export default SliderAliados;
